import { DocumentationV3, FormDocument } from 'epic/common-form/Documentation';
import { createSelector } from 'reselect';
import { QuoteFormError } from 'state/addonForm/addonForm.selector';
import { QuoteAction } from 'state/common-form/infos/infos.model';
import { EssentialFormInfos } from 'state/essential/infos/model';
import { AppState } from 'state/state.model';

export function selectEssentialFormInfos(state: AppState, tabId: string): EssentialFormInfos | undefined {
  return state.essential.infos?.[tabId];
}

export function selectEssentialFormInfosErrors(state: AppState, tabId: string) {
  return (state.essential.infos?.[tabId]?.validationErrors ?? []) as QuoteFormError[];
}

export const essentialFormInfoProductType = createSelector(
  [selectEssentialFormInfos],
  formInfos => formInfos?.instrumentName ?? '',
);

export const essentialFormInfoProductSubtype = createSelector(
  [selectEssentialFormInfos],
  formInfos => formInfos?.productDescription ?? '',
);

const emptyValidationErrorsArray: QuoteFormError[] = [];
export const selectEssentialValidationFormErrors = createSelector(
  [selectEssentialFormInfos],
  formInfos => formInfos?.validationErrors ?? emptyValidationErrorsArray,
);

export const selectEssentialsFormQuoteId = createSelector([selectEssentialFormInfos], formInfos => formInfos?.quoteId);

const emptyActionsArray: QuoteAction[] = [];
export const selectEssentialsActions = createSelector(
  [selectEssentialFormInfos],
  formInfos => formInfos?.actions ?? emptyActionsArray,
);

const emptyDocsArray: FormDocument[] = [];

export const selectEssentialFormInfosDocuments = createSelector([selectEssentialFormInfos], formInfos => {
  return formInfos?.documentation?.docs ?? emptyDocsArray;
});

export const selectEssentialFormInfosDocs = createSelector(
  [selectEssentialFormInfos],
  (formInfos): FormDocument[] | undefined => {
    const documentation = formInfos?.documentation;
    return documentation && 'docs' in documentation ? (documentation as DocumentationV3).docs : undefined;
  },
);
